import React from 'react';

// The main difference between "hooks/useBulkSelect" and this implementation is that
// this is the old version of useBulkSelect hook where bulk select works only per page.

// TODO: this hook should be removed after hooks/useBulkSelect will be used everywhere

export const useBulkSelect = () => {
  const [bulkSelectedItems, setBulkSelectedItems] = React.useState<string[]>([]);

  const handleBulkSelectAllClick = (selectedItems: string[]) => {
    setBulkSelectedItems(selectedItems);
  };

  const handleBulkSelect = (uuid: string) => {
    const selectedIndex = bulkSelectedItems.indexOf(uuid);

    let newSelected: string[];
    if (selectedIndex === -1) {
      newSelected = [...bulkSelectedItems, uuid];
    } else {
      newSelected = bulkSelectedItems.filter((itemUuid) => itemUuid !== uuid);
    }

    setBulkSelectedItems(newSelected);
  };

  const isBulkSelected = (name: string) => bulkSelectedItems.indexOf(name) !== -1;

  return {
    isBulkSelected,
    bulkSelectedItems,
    handleBulkSelectAllClick,
    handleBulkSelect,
  };
};
